import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { formatRxSelectorLabel } from '../../../../constants/rx-names';
import { RxImageViewerDialogComponent } from './rx-confirm-dialog.component';

@Component({
  selector: 'app-rx-compare-dialog',
  template: `
    <h2 mat-dialog-title>COMPARE PRESCRIPTIONS</h2>
    <mat-dialog-content>
      <div class="rx-compare-grid">
        <div class="rx-compare-pane" *ngFor="let pane of panes">
          <div class="rx-compare-title">{{ pane.label }}</div>
          <div class="rx-compare-image">
            <img
              *ngIf="pane.image"
              [src]="pane.image"
              alt="RX"
              (click)="openImage(pane.image)"
            >
            <span *ngIf="!pane.image">NO IMAGE</span>
          </div>
          <table class="rx-compare-values">
            <thead>
              <tr>
                <th></th>
                <th>SPH</th>
                <th>CYL</th>
                <th>AXIS</th>
                <th>ADD</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>RIGHT</td>
                <td>{{ pane.right.sph }}</td>
                <td>{{ pane.right.cyl }}</td>
                <td>{{ pane.right.axis }}</td>
                <td>{{ pane.right.add }}</td>
              </tr>
              <tr>
                <td>LEFT</td>
                <td>{{ pane.left.sph }}</td>
                <td>{{ pane.left.cyl }}</td>
                <td>{{ pane.left.axis }}</td>
                <td>{{ pane.left.add }}</td>
              </tr>
            </tbody>
          </table>
          <div class="rx-compare-meta" *ngIf="pane.notes">
            Notes: {{ pane.notes }}
          </div>
        </div>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button type="button" (click)="dialogRef.close()">CLOSE</button>
    </mat-dialog-actions>
  `,
  styles: [
    `
      .rx-compare-grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: auto auto;
        gap: 16px;
        min-width: 880px;
      }
      .rx-compare-title {
        font-weight: 700;
        letter-spacing: 0.04em;
        margin-bottom: 8px;
      }
      .rx-compare-image {
        min-height: 280px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #f5f5f5;
        margin-bottom: 12px;
      }
      .rx-compare-image img {
        max-width: 100%;
        max-height: 360px;
        object-fit: contain;
        cursor: pointer;
      }
      .rx-compare-values {
        width: 100%;
        border-collapse: collapse;
        font-size: 13px;
      }
      .rx-compare-values th,
      .rx-compare-values td {
        text-align: left;
        padding: 6px 4px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.12);
      }
      .rx-compare-meta {
        margin-top: 8px;
        font-size: 12px;
        color: rgba(0, 0, 0, 0.64);
      }
    `,
  ],
})
export class RxCompareDialogComponent {
  panes: Array<{
    label: string;
    image: string;
    notes: string;
    right: any;
    left: any;
  }> = [];

  constructor(
    public dialogRef: MatDialogRef<RxCompareDialogComponent>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA)
    public data: { prescriptions?: any[]; left?: any; right?: any }
  ) {
    const list = Array.isArray(data?.prescriptions)
      ? data.prescriptions.slice(0, 4)
      : [data?.left, data?.right].filter(Boolean);
    this.panes = list.map((rx) => ({
      label: formatRxSelectorLabel(rx),
      image: String(
        rx?.sourceImageDataUrl ||
          rx?.images?.[0]?.url ||
          rx?.images?.[0]?.dataUrl ||
          ''
      ).trim(),
      notes: String(rx?.notes || '').trim(),
      right: rx?.right || {},
      left: rx?.left || {},
    }));
  }

  openImage(image: string): void {
    if (!image) {
      return;
    }
    this.dialog.open(RxImageViewerDialogComponent, {
      data: { image },
      hasBackdrop: false,
      autoFocus: false,
      position: { right: '16px', top: '72px' },
    });
  }
}
